import React from 'react';

export interface EmptyStateProps {
  illustration?: React.ReactNode;
  title?: string;
  titleClassName?: string;
  description?: string;
  descriptionClassName?: string;
  content?: React.ReactNode | string;
  className?: string;
  testID?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  illustration,
  title,
  titleClassName = '',
  description,
  descriptionClassName = '',
  content = '',
  className = '',
  testID,
}) => {
  const componentTestId = testID ? `${testID}-empty-state` : 'empty-state';

  return (
    <div
      data-testid={componentTestId}
      className={`flex flex-col items-center justify-center p-6 text-center ${className}`}
    >
      {illustration}

      <div className="mt-5 gap-1.5 flex flex-col items-center">
        {title && (
          <h2
            data-testid={`${componentTestId}-header`}
            className={`text-xl font-semibold text-foreground ${titleClassName}`}
          >
            {title}
          </h2>
        )}

        {description && (
          <p
            data-testid={`${componentTestId}-description`}
            className={`text-base text-gray-500 max-w-md ${descriptionClassName}`}
          >
            {description}
          </p>
        )}

        {content &&
          (React.isValidElement(content) ? (
            content
          ) : (
            <p
              data-testid={`${componentTestId}-content`}
              className="text-base text-gray-500 max-w-md"
            >
              {content}
            </p>
          ))}
      </div>
    </div>
  );
};
